import "../styles/pages.scss";
import backgroud from "../assets/img/aboutBack.png";
import scroll from "../assets/img/Scroll.png";
import { AboutCard1, AboutCard1_1 } from "../components/AboutCard1";
import aboutPic1 from "../assets/img/q1.png";
import aboutPic2 from "../assets/img/q2.png";
import aboutPic3 from "../assets/img/q3.png";
import aboutPic7 from "../assets/img/aboutPic7.png";
import { Data } from "../Location";
import { useEffect, useRef, useState } from "react";
import { Tween } from "../Tween";

export function AboutUs() {
    const [data, setData] = useState(null);
    useEffect(() => {
        Data().then((r) => {
            setData(r);
            const texts = [
                r.about.MainText1,
                r.about.MainText2,
                r.about.MainText3,
            ];
            SetAni(texts, 1);
        });
    }, []);
    const textRef = useRef(null);
    function SetAni(text, index) {
        const dur = 500;
        let t;
        t = Tween({
            from: 0,
            to: 1,
            duration: dur,
            onUpdate: (i) => {
                if (textRef.current) {
                    textRef.current.style.opacity = i;
                } else {
                    t.Kill();
                }
            },
            onComplete: () => {
                t = Tween({
                    from: 1,
                    to: 0,
                    duration: dur,
                    onUpdate: (i) => {
                        if (textRef.current) {
                            textRef.current.style.opacity = i;
                        } else {
                            t.Kill();
                        }
                    },
                    onComplete: () => {
                        if (textRef.current) {
                            textRef.current.innerHTML =
                                text[index % text.length];
                            SetAni(text, index + 1);
                        }
                    },
                });
            },
        });
    }
    return (
        <div className="page">
            <img className="pageBackground" src={backgroud} />
            <img className="pageBackgroundScroll" src={scroll} />
            <div className="pageTop">
                <div className="aboutTitle1" ref={textRef}>
                    {data ? data.about.MainText1 : ""}
                </div>
            </div>
            <div className="pageContent">
                <div className="aboutTitle">
                    {data && data.home.AboutTitle}
                    <img src={aboutPic7} />
                </div>
                <div className="aboutContent1">
                    <AboutCard1
                        img={aboutPic1}
                        title={data ? data.about.HistoryTitle : ""}
                        text={data ? data.about.HistoryText : ""}
                    />
                    <AboutCard1_1
                        img={aboutPic2}
                        title={data ? data.about.PlusTitle : ""}
                        text={data ? data.about.PlusText : ""}
                    />
                    <AboutCard1
                        img={aboutPic3}
                        title={data ? data.about.ToYouTitle : ""}
                        text={data ? data.about.ToYouText : ""}
                    />
                </div>
            </div>
        </div>
    );
}
